module.exports = __webpack_public_path__ + "static/media/json.a9fa5684.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/json.svg
// module id = 1674
// module chunks = 17